exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ModulesTreemap__container,.ModulesTreemap__map{position:relative;width:100%;height:100%}.ModulesTreemap__sidebarGroup{margin-bottom:20px}.ModulesTreemap__activeSize{font-weight:700}", ""]);

// exports
exports.locals = {
	"container": "ModulesTreemap__container",
	"map": "ModulesTreemap__map",
	"sidebarGroup": "ModulesTreemap__sidebarGroup",
	"activeSize": "ModulesTreemap__activeSize"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"minimize":true,"localIdentName":"[name]__[local]"}!./client/components/ModulesTreemap.css
// module id = 17
// module chunks = 0